export default __webpack_public_path__ + "static/media/qs-white.503b495d.svg";